import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_entity_ext_RowInterface} from "../../../dbschema";

export class EntityExtensionContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_ext: bl_fi_mst_entity_ext_RowInterface[] = [];

}
